<div
  class="rise-data-table-container attribute-editor-component data-table-component"
  rvSpinner="data-table-editor-loader"
  [rvShowSpinner]="spinner"
>
  @if (!source && !componentAccount) {
    <div #scrollContainer class="data-items-list te-scrollable-container">
      <div class="attribute-editor-row">
        <label>Import data</label>
        @if (featuresService.isFeatureAvailable('google_sheets')) {
          <button
            [id]="controlId('select-google-sheet')"
            type="button"
            matButton="outlined"
            class="tw-w-full button-role--provider"
            (click)="selectGoogleSheet()"
          >
            <mat-icon svgIcon="sheet" class="no-stroke" aria-hidden="true" />
            <span>Google Sheet</span>
          </button>
        } @else {
          <button
            [id]="controlId('select-google-sheet')"
            type="button"
            matButton="outlined"
            class="tw-w-full button-role--provider"
            (click)="featuresService.showUpgradePlanModal('google_sheets')"
          >
            <mat-icon svgIcon="sheet" class="no-stroke" aria-hidden="true" />
            <span>Google Sheet</span>
            <upgrade-notice feature="google_sheets"></upgrade-notice>
          </button>
        }
        @if (driveError) {
          <p class="help-block text-danger !tw-m-0">
            We couldn't connect to Google Drive. Try again.
          </p>
        }
      </div>
      <div class="attribute-editor-row">
        <input
          #csvUploadInput
          [id]="controlId('upload-csv')"
          type="file"
          [hidden]="true"
          (change)="importCsv($event)"
          accept=".csv"
        />
        <button
          type="button"
          matButton="outlined"
          class="tw-w-full tw-mb-[7.5px] button-role--provider"
          (click)="csvUploadInput.click()"
        >
          <mat-icon svgIcon="upload" aria-hidden="true" /> Upload CSV
        </button>
      </div>
      <ng-container *ngTemplateOutlet="defineFields"></ng-container>
      <div class="attribute-editor-row">
        <label>Edit data</label>
        <rv-sortable [sortableService]="sortableService">
          @for (item of values; track item; let rowIndex = $index) {
            <div rvSortableItem class="row data-item-row row-hover">
              <rv-sortable-handle></rv-sortable-handle>
              <div class="data-table-fields mr-auto w-100">
                @for (field of fields; track field; let key = $index) {
                  @if (!field.hidden) {
                    @if (field.type === 'image') {
                      <div class="data-table-image-field">
                        <div
                          class="data-table-image-thumbnail"
                          aria-hidden="true"
                        >
                          @if (item[key] && !invalidUrls.has(item[key])) {
                            <img [src]="item[key]" alt="" />
                          }
                        </div>
                        <div class="data-table-image-controls">
                          <input
                            type="text"
                            class="form-control"
                            [(ngModel)]="item[key]"
                            [attr.aria-label]="field.name"
                            placeholder="Enter URL"
                            (ngModelChange)="save()"
                          />
                          <button
                            rv-button
                            variant="secondary"
                            type="button"
                            class="tw-w-full"
                            (click)="selectFromStorage(item, key)"
                          >
                            Choose from storage
                          </button>
                          @if (invalidUrls.has(item[key])) {
                            <div class="has-error">
                              <p class="help-block">
                                @switch (invalidUrls.get(item[key])) {
                                  @case ('INVALID_PROTOCOL') {
                                    <span
                                      >URL should start with "https://"</span
                                    >
                                  }
                                  @case ('INVALID_EXTENSION') {
                                    <span
                                      >Image type is invalid. Valid types:
                                      JPG,JPEG,PNG,BMP,SVG,GIF,WEBP</span
                                    >
                                  }
                                }
                              </p>
                            </div>
                          }
                        </div>
                      </div>
                    } @else {
                      <div>
                        <div class="flex-row mt-2">
                          <label
                            class="data-table-label"
                            [title]="field.name"
                            >{{ field.name }}</label
                          >
                          <input
                            [shown]="field.type === 'text'"
                            type="text"
                            class="form-control"
                            [(ngModel)]="item[key]"
                            [attr.aria-label]="field.name"
                            placeholder="Enter {{ field.name }}"
                            (ngModelChange)="save()"
                          />
                          <textarea
                            [shown]="field.type === 'multiline'"
                            class="form-control resize-vertical"
                            rows="2"
                            [(ngModel)]="item[key]"
                            [attr.aria-label]="field.name"
                            placeholder="Enter {{ field.name }}"
                            (ngModelChange)="save()"
                          ></textarea>
                        </div>
                      </div>
                    }
                  }
                }
              </div>
              <button
                type="button"
                class="data-table-remove-item"
                aria-label="Remove item"
                matTooltip="Remove item"
                matTooltipShowDelay="300"
                (click)="removeItem(rowIndex)"
              >
                <mat-icon svgIcon="trash" aria-hidden="true"></mat-icon>
              </button>
            </div>
          }
        </rv-sortable>
      </div>

      <div class="attribute-editor-row">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <div class="flex-row flex-wrap space-between mt-3">
                <button
                  rv-button
                  variant="secondary"
                  [id]="controlId('export-csv')"
                  type="button"
                  class="tw-w-full"
                  (click)="exportCsv()"
                >
                  <mat-icon svgIcon="download" aria-hidden="true" />
                  Download data as CSV
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="attribute-editor-row">
      <button
        rv-button
        variant="secondary"
        [id]="controlId('add-row')"
        type="button"
        class="tw-w-full"
        (click)="addRow()"
      >
        <mat-icon svgIcon="add-item" aria-hidden="true" /> Add Item
      </button>
    </div>
  }

  @if (source || componentAccount) {
    <div
      class="data-items-list data-items-list--no-footer te-scrollable-container"
    >
      <div class="attribute-editor-row">
        <div class="row">
          <div class="col-xs-12">
            <label class="pb-3">My Sheet File</label>
            <div class="provider-connected-container form-group">
              <div class="account-info">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg"
                  alt="Google"
                  class="account-logo"
                />
                <span class="account-email">{{
                  componentAccountUsername
                }}</span>
              </div>
              <div class="provider-connected-file-info">
                <div class="file-details">
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/a/ae/Google_Sheets_2020_Logo.svg"
                    class="file-icon"
                    alt="Google Sheets"
                  />
                  <div class="file-text">
                    @if (!source) {
                      <span class="file-item-count">No file selected</span>
                    } @else {
                      <span class="file-title">{{ selectedName }}</span>
                      @if (sheetValues.rowCount > maxRows) {
                        <span class="file-item-count">{{ maxRows }} rows</span>
                      } @else {
                        <span class="file-item-count"
                          >{{ sheetValues.rowCount }} rows</span
                        >
                      }
                    }
                  </div>
                </div>
                <button
                  class="btn btn-icon pr-0"
                  mat-icon-button
                  aria-label="Open file options"
                  [matMenuTriggerFor]="fileOptions"
                  (menuOpened)="onDropdownOpen()"
                >
                  <i
                    aria-hidden="true"
                    class="fa fa-chevron-down file-options-icon"
                    [ngClass]="{ clicked: isDropdownOpen }"
                  ></i>
                </button>
                <mat-menu
                  #fileOptions="matMenu"
                  xPosition="before"
                  (closed)="onDropdownClose()"
                >
                  @if (source && !fileAccessFailed) {
                    <button mat-menu-item (click)="refreshSheet()">
                      <streamline-icon
                        aria-hidden="true"
                        class="mr-3 streamline-component-icon"
                        name="refresh"
                        width="16"
                        height="16"
                      ></streamline-icon>
                      <span>Refresh Sheet</span>
                    </button>
                  }
                  @if (source && !fileAccessFailed) {
                    <button mat-menu-item (click)="openGoogleSheet()">
                      <streamline-icon
                        aria-hidden="true"
                        class="mr-3 streamline-component-icon"
                        name="arrowDiagonalRight"
                        width="16"
                        height="16"
                      ></streamline-icon>
                      <span>Open in Google Sheets</span>
                    </button>
                  }
                  <button mat-menu-item (click)="changeFile()">
                    <streamline-icon
                      aria-hidden="true"
                      class="mr-3 streamline-component-icon"
                      name="fileInverted"
                      width="16"
                      height="16"
                    ></streamline-icon>
                    <span>Select a different Sheet</span>
                  </button>
                  <button mat-menu-item (click)="editManually()">
                    <streamline-icon
                      aria-hidden="true"
                      class="mr-3 streamline-component-icon"
                      name="editSheet"
                      width="16"
                      height="16"
                    ></streamline-icon>
                    <span>Unlink Sheet and edit manually</span>
                  </button>
                  @if (sameAccount) {
                    <rv-divider class="tw-my-[8px]" />
                    <button mat-menu-item (click)="confirmDisconnect()">
                      <streamline-icon
                        aria-hidden="true"
                        class="mr-3 streamline-component-icon"
                        name="unlink"
                        width="16"
                        height="16"
                      ></streamline-icon>
                      <span>Disconnect from Google</span>
                    </button>
                  }
                </mat-menu>
              </div>
            </div>
            @if (driveError) {
              <p class="help-block text-danger !tw-m-0">
                We couldn't connect to Google Drive. Try again.
              </p>
            }
          </div>
        </div>
      </div>
      @if (fileAccessFailed) {
        <div class="attribute-editor-row">
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <div class="provider-file-error has-error">
                  <streamline-icon
                    aria-hidden="true"
                    class="error-icon mr-3"
                    name="xmark"
                    width="24"
                    height="24"
                  ></streamline-icon>
                  <div>
                    <p class="help-block mt-1 font-weight-bold">
                      Uh oh! We can't find your file.
                    </p>
                    <p>
                      It looks like it might have been moved or been deleted.
                      Select another Google Sheet to update your presentation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <div class="attribute-editor-row">
        <p class="tw-text-[13px]">
          @if (helpText) {
            {{ helpText }}
          } @else {
            @if (idPrefix === 'layout-table') {
              Ensure your Google Sheet is formatted correctly: Each column
              corresponds to the fields below. The image field should contain an
              image URL, and the other columns should contain text. Data updates
              every 10 minutes.
            } @else {
              Edit your Google Sheet to update the list. Data updates every 10
              minutes.
            }
          }
          <a
            #googleSheetCsvLink
            [id]="googleSheetCsvElementId"
            href=""
            class="madero-link u_clickable"
            (click)="exportGoogleSheetCsv()"
            download="sheet-data.csv"
            >Download Example</a
          >
        </p>
      </div>
      <div class="attribute-editor-row hide-first-row">
        <div class="flex-row left-right-aligner">
          <label
            [for]="controlId('first-row')"
            [id]="controlId('first-row-label')"
            class="mb-0"
            >Hide first row</label
          >
          <mat-slide-toggle
            [id]="controlId('first-row')"
            class="pl-3"
            [checked]="sheetValues.hideFirstRow"
            (change)="hideFirstRowChanged()"
            [attr.aria-labelledby]="controlId('first-row-label')"
          ></mat-slide-toggle>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="defineFields"></ng-container>
    </div>
  }
</div>

<ng-template #defineFields>
  @if (canDefineFields) {
    <div class="attribute-editor-row define-fields">
      <label>Define fields</label>
      <div class="define-fields-list">
        @for (field of fields; track field; let fieldIndex = $index) {
          <div class="define-fields-row">
            <input
              type="text"
              class="form-control"
              [class.define-fields-input-locked]="field.type === 'image'"
              [(ngModel)]="field.name"
              [readonly]="field.type === 'image'"
              [attr.aria-label]="'Field name ' + (fieldIndex + 1)"
              placeholder="New field"
              (ngModelChange)="save()"
            />
            @if (field.deletable) {
              <button
                type="button"
                mat-icon-button
                class="define-fields-action"
                aria-label="Remove field"
                matTooltip="Remove field"
                matTooltipShowDelay="300"
                (click)="removeField(fieldIndex)"
              >
                <mat-icon svgIcon="close" aria-hidden="true"></mat-icon>
              </button>
            } @else {
              <button
                type="button"
                mat-icon-button
                class="define-fields-action"
                [attr.aria-label]="field.hidden ? 'Show field' : 'Hide field'"
                [matTooltip]="field.hidden ? 'Show field' : 'Hide field'"
                matTooltipShowDelay="300"
                (click)="toggleFieldVisibility(field)"
              >
                <mat-icon
                  [svgIcon]="field.hidden ? 'eye-close' : 'eye-open'"
                  aria-hidden="true"
                ></mat-icon>
              </button>
            }
          </div>
        }
      </div>
      <button
        rv-button
        variant="secondary"
        [id]="controlId('add-field')"
        type="button"
        class="tw-w-full"
        (click)="addField()"
      >
        <mat-icon svgIcon="add-item" aria-hidden="true" /> Add field
      </button>
    </div>
  }
</ng-template>
